import { PAGE_STATE_PRE_EVENT, PAGE_STATE_CHECK_IN, PAGE_STATE_DURING_EVENT } from 'common/constants/virtualEvent';

export function getMigrationFlags() {
    return {
        [PAGE_STATE_PRE_EVENT]: {
            isFeatureFlagEnabled: true,
            currentMigrationVersion: 1,
        },
        [PAGE_STATE_CHECK_IN]: {
            isFeatureFlagEnabled: true,
            currentMigrationVersion: 1,
        },
        [PAGE_STATE_DURING_EVENT]: {
            isFeatureFlagEnabled: true,
            currentMigrationVersion: 1,
        },
    };
}

export function shouldMigratePageState(pageState, pageStateMigrationVersion) {
    const migrationFlags = getMigrationFlags();
    const { isFeatureFlagEnabled, currentMigrationVersion } = migrationFlags[pageState];
    const isMigrationVersionUpToDate = pageStateMigrationVersion === currentMigrationVersion;

    return isFeatureFlagEnabled && !isMigrationVersionUpToDate;
}
